export default class ChangePollingInterval {
  constructor(context) {
    this.context = context;
  }

  run() {
    return;
  }
}
